import React, { useState } from 'react';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { makeStyles } from '@material-ui/core/styles';
import { Input } from '@material-ui/core';
import Icon from 'storybookComponents/Icon';
import Typography from 'storybookComponents/Typography';
import Button from 'storybookComponents/Button';
import 'bootstrap/dist/css/bootstrap.css';
import "./style.css"

const useStyles = makeStyles((theme) => ({
  arrow: {
    color: "white",
    marginTop: -8,
    textAlign: "center",
  },
  container: {
    position: "relative"
  },
  content: {
    padding: 12,
  },
  title: {
    color: "rgba(51, 51, 51, 0.5)",
    fontSize: 14,
    fontWeight: 600,
  },
  field: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 16
  },
  label: {
    fontSize: 16,
    display: "flex",
    alignItems: "center"
  },
  input: {
    textAlign: "center",
    width: 96,
    padding: 8,
    color: "black !important;",
    border: "1px solid #dadada",
    "&:hover": {
      border: "1px solid #26bbed",
    },
    "&:focus": {
      border: "1px solid #999999",
    }
  },
  counter: {
    display: "flex",
    border: "1px solid #eee",
    justifyContent: "space-evenly",
    alignItems: "center",
    width: 120,
    textAlign: "center"
  },
  count: {
    borderRight: "1px solid #eee",
    borderLeft: "1px solid #eee",
    padding: "8px 16px",
    borderTop: "none !important",
    borderBottom: "none !important",
    textAlign: "center",
    color: "black !important",
    width: 45
  },
  infoIcon: {
    cursor: "pointer",
    "&:hover": {
      color: "#26bbed"
    }
  },
  container: {
    background: "white !important"
  },
  buttonStyle: {
    marginTop: 24,
    boxShadow: "none !important"
  },
  arrowFill: {
    fill: "black"
  },
  mainContainer: {
    marginTop: 30,
    marginBottom: 20,
  },
  iconStyle: {
    cursor: 'pointer',
    "&:hover": {
      color: "#26bbed"
    }
  },
  tooltip: {
    background: "white",
    color: "black",
    fontSize: 12,
    border: "1px solid #dadada",
    width: 200,
    padding: 10,
    borderRadius: 5,
    fontFamily: "Open Sans"
  },
  rightIcons: {
    display: "flex",
    width: 50,
    justifyContent: "space-between"
  },
  disabled: {
    pointerEvents: "none",
    color: "#b4b3b3"
  }

}));

const Counter = ({ max, min, keyName, onChange, defaultValue }) => {
  const maximum = max || 30;
  const minimum = min || 0;

  const classes = useStyles();
  const [count, setCount] = React.useState(defaultValue || minimum);
  React.useEffect(() => {
    if (typeof onChange === "function") {
      if (keyName) onChange(keyName, count)
      else onChange(count)
    }
  }, [count])

  React.useEffect(() => {
    if (count > max || count < min) {
      setCount(0)
    }
  }, [max])

  const increment = () => {
    if (count < maximum) {
      setCount(count + 1)
    }
  }

  const decrement = () => {
    if (count > minimum) {
      setCount(count - 1)
    }
  }

  const onInputChange = (evt) => {
    let value = Number(evt.target.value)
    if (!value) setCount(0)
    if (!isNaN(value)) {
      if (value < maximum && value > minimum) {
        setCount(value)
      }
    }
  }

  return (
    <div>
      <div className={classes.counter}>
        <div className={`${classes.iconStyle} ${count === minimum && classes.disabled}`}>
          <Icon type="icon-e-delete" onClick={decrement} />
        </div>
        <input className={classes.count} value={count} onChange={onInputChange} />
        <div className={`${classes.iconStyle} ${count === maximum && classes.disabled}`}>
          <Icon type="icon-e-add" onClick={increment} />
        </div>
      </div>
    </div>
  )
}


const SimplePopover = ({ maxNoOfGuests, maxAdditionalGuests, setFieldValue, popoverId }) => {
  const classes = useStyles();
  const [popoverOpen, setPopoverOpen] = useState(false);

  const toggle = () => setPopoverOpen(!popoverOpen);

  const saveGuestValue = (evt) => {
    setFieldValue("maxNoOfGuests", Number(evt.target.value))
  }
  return (
    <div id="guest-input-container" className={classes.mainContainer}>
      <div className="guest-input" id={popoverId} onClick={toggle}>
        <span style={{ color: "#9a9a9a" ,fontSize:16}}>Additional Guest(s)*</span>
        <span className={classes.rightIcons}>
          <Icon type="icon-pencil" size="sm" />
          <ArrowDropDownIcon className={classes.arrowFill} />
        </span>
      </div>
      <Popover placement="bottom-end" isOpen={popoverOpen} target={popoverId} toggle={toggle} className="guest-popover">
        <PopoverBody>
          <div className={`hyly-rsvp-form ${classes.container}`}>
            <div><Typography type="body" className={classes.title}>Edit Additional Guest(s)</Typography></div>
            <div className={classes.field}>
              <Typography type="body" className={classes.label}>RSVP Capacity</Typography>
              <div>
                <Input disableUnderline type="number" value={maxNoOfGuests} onChange={saveGuestValue} placeholder="0" classes={{ input: classes.input }} />
              </div>
            </div>
            <div className={classes.field}>
              <Typography type="body" className={classes.label}>
                Max. guests per RSVP &nbsp;
                <div className={`${classes.infoIcon} tooltipguest`}>?
                  <span className="tooltiptext">
                    <div>
                      <div>It is additional guests that you allow along with each RSVPed person to join the event.</div>
                      <br />If max. guests per RSVP is set to ‘0’ then this field itself will not be displayed for the prospects.
                    </div>
                  </span>
                </div>
                {/* <Tooltip classes={{
                  tooltip: classes.tooltip
                }} show_tooltip
                  is_html tooltip_text={`<div><div>It is additional guests that you allow along with each RSVPed person to join the event.</div> <br/>If max. guests per RSVP is set to ‘0’ then this field itself will not be displayed for the prospects.</div>`} placement="top">
                  <div className={classes.infoIcon} >?</div>
                </Tooltip> */}
                &nbsp;&nbsp;&nbsp;&nbsp;
              </Typography>
              <div>
                <Counter max={maxNoOfGuests} defaultValue={maxAdditionalGuests} keyName="maxAdditionalGuests" onChange={setFieldValue} />
              </div>
            </div>
            <Button color="hylyBlue" onClick={toggle} className={classes.buttonStyle} variant="primary" size="md">
              Done
            </Button>
          </div>
        </PopoverBody>
      </Popover>
    </div>
  );
}

export default SimplePopover;